import React, { useState } from "react";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa";
import logo from "../../assets/UMSImage/LogoKit/UMS-Logo-Gradient.png";
import "./header.scss";
import Button from "../../components/Common/Button/Button";
import { HeaderMenu } from "../../constants/Header";
import { NavLink, useNavigate } from "react-router-dom";
import Popup from "../../components/Common/Popup/Popup";
import ContactUs from "../../components/ContactUs/ContactUs";
import { CgMenu } from "react-icons/cg";
import { useEffect } from "react";
import scrollLogo from "../../assets/Menu_Logo.png"

const Header = () => {
  const naviagte = useNavigate();
  const menuToggle = window.location.pathname === "/";
  const [PopUpToggle, setPopUpToggle] = useState(false);
  const [isToggled, setToggled] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleClick = () => {
    setToggled(!isToggled);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleGetAQuote =()=>{
    naviagte('/get-a-quote')
  }
  return (
    <>
      <div id="contact-header">
        <div className="email">
          <MdEmail size={20} /> &nbsp;
          <a href="Mailto:support@theums.us">support@theums.us</a>
        </div>
        <div className="phone">
          <FaPhone size={16} style={{ transform: "rotate(90deg)" }} />
          &nbsp;
          <a href="tel:+13026080876">(302) 608-0876</a>
        </div>
      </div>

      <header id="header">
        <nav className="navbar  navbar-expand-lg navbar-dark  scrolling-navbar">
          <a className="navbar-brand" href="#">
            <img src={scrolled ? scrollLogo : logo} className={scrolled ? "scroll" : "unscroll"} alt="logo" />
          </a>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              {HeaderMenu.map((item) => {
                return (
                  <>
                    <li className="nav-item active">
                      <NavLink className="nav-link" to={item?.path}>
                        {item?.title}
                      </NavLink>
                    </li>
                  </>
                );
              })}
              <li className="nav-item active">
                <a className="nav-link" onClick={() => setPopUpToggle(true)}>
                  Contact
                </a>
              </li>
              <li className="mob-visible">
                <Button id="arrow-wrapper-right" onClick={handleGetAQuote}>Get a Quote</Button>
              </li>
            </ul>
          </div>
          <div className="mob-hide">
            <Button id="arrow-wrapper-right" onClick={handleGetAQuote}>Get a Quote</Button>
          </div>
          <button
            // className="navbar-toggler hamburger__toggle"
            className={` navbar-toggler hamburger__toggle ${
              isToggled ? "toggled" : ""
            }`}
            onClick={handleClick}
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="hamburger__icon">
              {/* <CgMenu color="black" size={28} className="menu-toggole" /> */}
            </span>
          </button>
        </nav>
      </header>
      {PopUpToggle && (
        <Popup onClick={() => setPopUpToggle(false)}>
          <ContactUs />
        </Popup>
      )}
    </>
  );
};

export default Header;
